












import Vue from 'vue'
import Component from 'vue-class-component'
import moment from 'moment-timezone'
import { User } from '@/classes/User'
import Api from '@/api'

@Component({
  name: 'DateTimeLabel',
  props: {
    date: [Date, String],
    showDate: {
      type: Boolean,
      default: true
    },
    showTime: {
      type: Boolean,
      default: true
    },
    oneRow: {
      type: Boolean,
      default: false
    },
    useUserTimezone: {
      type: Boolean,
      default: true
    },
    utc: {
      type: Boolean,
      default: false
    },
    noUtcOffset: {
      type: Boolean,
      default: false
    },
    types: {
      type: Array,
      default: () => {
        return []
      }
    },
    displayInEst: {
      type: Boolean,
      default: false
    }
  }
})
export default class DateTimeLabel extends Vue {
  user = Api.getUser() as User

  get classes () {
    const classes: any = {}
    this.$props.types.forEach((type: string) => {
      classes[type] = true
    })

    return classes
  }

  get dateLabel () {
    if (!this.isValidDate) {
      return ''
    }
    if (this.$props.displayInEst) {
      return moment(this.$props.date).tz('America/New_York').format('MM/DD/YYYY')
    }
    if (this.$props.utc) {
      return moment.utc(this.$props.date).format('MM/DD/YYYY')
    }
    return moment(this.$props.date).format('MM/DD/YYYY')
  }

  get timeLabel () {
    if (!this.isValidDate) {
      return ''
    }
    if (this.$props.noUtcOffset) {
      return moment(this.$props.date).format('hh:mm A')
    }
    if (this.$props.displayInEst) {
      return moment(this.$props.date).tz('America/New_York').format('hh:mm A')
    }
    if (this.$props.useUserTimezone) {
      return moment(this.$props.date).utcOffset(this.user.getTimezone() * 60).format('hh:mm A')
    }
    return moment(this.$props.date).utc(this.$props.utc).format('hh:mm A')
  }

  get isValidDate () {
    return moment(this.$props.date).isValid() === true
  }
}
